import Security from '../Profile/Security';

const AdminSecurityPage = () => (
  <div className='bg-secondary min-height'>
    <div className='container'>
      <div className='queued-page-header justify-between align-center'></div>
      <div className='d-flex justify-center'>
        <Security />
      </div>
    </div>
  </div>
);

export default AdminSecurityPage;
